// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    width: 100%;
    background-color: #6b21a8;
    color: white;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
}

.navbar .container {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
}

.navbar .container .logo {
    font-size: 1.5em;
    font-weight: bold;
    color: white;
}

.navbar .container .menu-button {
    padding: 4px;
    border-radius: 4px;
    border: none;
    outline: none;
    background-color: transparent;
}

.navbar .container .menu-button:hover {
    border: 1px solid #ccc;
}

.navbar .container .menu-button .icon {
    width: 24px;
    height: 24px;
    fill: white;
}

.navbar .container .menu {
    display: none;
}

.navbar .container .menu.active {
    display: flex;
}

.navbar .container .menu ul {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.navbar .container .menu ul li {
    margin: 0 10px;
    color: white;
}

.navbar .container .menu ul li a {
    color: white;
    text-decoration: none;
}

.navbar .container .menu ul li a.active,
.navbar .container .menu ul li a:hover {
    color: #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/View/Client/navbar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;AACf","sourcesContent":[".navbar {\n    width: 100%;\n    background-color: #6b21a8;\n    color: white;\n    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);\n}\n\n.navbar .container {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 20px;\n}\n\n.navbar .container .logo {\n    font-size: 1.5em;\n    font-weight: bold;\n    color: white;\n}\n\n.navbar .container .menu-button {\n    padding: 4px;\n    border-radius: 4px;\n    border: none;\n    outline: none;\n    background-color: transparent;\n}\n\n.navbar .container .menu-button:hover {\n    border: 1px solid #ccc;\n}\n\n.navbar .container .menu-button .icon {\n    width: 24px;\n    height: 24px;\n    fill: white;\n}\n\n.navbar .container .menu {\n    display: none;\n}\n\n.navbar .container .menu.active {\n    display: flex;\n}\n\n.navbar .container .menu ul {\n    display: flex;\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n}\n\n.navbar .container .menu ul li {\n    margin: 0 10px;\n    color: white;\n}\n\n.navbar .container .menu ul li a {\n    color: white;\n    text-decoration: none;\n}\n\n.navbar .container .menu ul li a.active,\n.navbar .container .menu ul li a:hover {\n    color: #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
